<section class="textual-content-wrapper" [ngClass]="fieldConfig.cssClasses">
  <span *ngIf="fieldConfig.label && showTitle" class="content-title">{{fieldConfig.label}}</span>
  <ng-container *ngFor="let item of values; trackBy: trackByMethod" [ngSwitch]="fieldConfig.type">
    <ng-container *ngIf="needShowValue(item.value) || showTitle">
      <ng-container *ngIf="needShowValue(item.value);else noResult">
      <div *ngSwitchCase="'link'">
        <a (click)="linkClicked(item.value)"
           [href]="item.link"
           class="textual-content link-content value-item AUTO_VALUE" [ngClass]="fieldConfig.itemCssClass ?  fieldConfig.itemCssClass : ''"
           target="_blank" gen-hyphens [shouldHyphenate]="hyphenate" [reapply]="reapply">{{item.value}}</a>
      </div>
        <div *ngSwitchCase="'text-with-link'">
          <a (click)="linkClicked(item.value)"
             class="textual-content link-content value-item AUTO_VALUE" [ngClass]="fieldConfig.itemCssClass ?  fieldConfig.itemCssClass : ''"
             target="_blank" gen-hyphens [shouldHyphenate]="hyphenate" [reapply]="reapply">{{item.value}}</a>
        </div>
      <i *ngIf = "icon && icon.name && item.value" class="{{(icon.cssClass) ? icon.cssClass + ' icon_item' : 'icon_item'}} {{icon.name}}" [ngStyle]= "{'float' : (icon.position) ? icon.position : 'left'}"></i>
      <span *ngSwitchDefault
            gen-hyphens
            genTooltip
            class="textual-content value-item AUTO_VALUE"
            [innerHTML]="(!isItDefault) ? escapeChevron(item.value) : (trimwhiteSpace(escapeChevron((item.value == 'Unknown')?'Default_Unknown':item.value)) | translate)"
            [ngClass]="fieldConfig.itemCssClass ?  fieldConfig.itemCssClass : 'padding-above'"
            [reapply]="reapply"
            [shouldHyphenate]="hyphenate"
            [tooltipConfiguration]="tooltipConfiguration"
            [tooltipData]="tooltipData"
            [tooltipPosition]="tooltipPosition"
            [tooltipText]="tooltipText"
      >
      </span>
    </ng-container>
    </ng-container>
  </ng-container>
</section>

<ng-template #noResult>
  <section  class="no-results Auto_NoResults_Text">
    <ng-content></ng-content>
  </section>
</ng-template>
